<template>
    <div class="chat-input">
        <div class="icon">
            <img src="@/assets/img/camera.svg" @click="openCamera">
            <input type="file" accept="image/*" capture="environment" ref="camera" @change="pushPic" hidden>
        </div>
        <div class="icon">
            <img src="@/assets/img/pic.svg" @click="onenPic">
            <input type="file" accept="image/*" ref="pic" @change="pushPic"  hidden>
        </div>
        <div class="input">
            <textarea
                    ref="textarea"
                    v-model="content"
                    @keydown.enter.exact.prevent
                    @keyup.enter.exact="enterMessage"
                    @keydown.enter.shift="newline"
                    placeholder="給騎士的訊息"
                    :style="{height: height, minHeight: '41px', maxHeight: '150px'}"></textarea>
            <img src="@/assets/img/sent.svg" v-show="content" @click="pushMessage">
        </div>
    </div>
</template>

<script>
    import { pushOrderMessage } from "../../../apis";
    import Compressor from 'compressorjs';
    import {mapGetters} from "vuex";
    import moment from 'moment';

    export default {
        name: "ChatInput",
        data() {
            return {
                content: '',
                enterTime: 0,
            }
        },
        computed: {
            height() {
                if (! this.content) {
                    return '2em';
                }

                let height = this.content.split('\n').length + 1;

                return `${height * 1.3}em`;
            },
            isMobile() {
                if(! /AppleWebKit.*Mobile/i.test(navigator.userAgent) &&
                    ! /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent) &&
                    ! /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)){
                    return false;
                }

                return true;
            },
            ...mapGetters(['user'])
        },
        methods: {
            onenPic() {
               this.$refs.pic.click();
            },
            openCamera() {
               this.$refs.camera.click();
            },
            newline() {
                this.enterTime = new Date().getTime();
            },
            pushPic(event) {
                let file = event.target.files[0];
                if (!file) {
                    return;
                }

                let self = this;
                new Compressor(file,{
                    quality: 0.6,
                    success(result) {
                        let formData = new FormData();
                        formData.append('photo', result, result.name);
                        formData.append('type', 'photo');

                        let payload = {
                            id: self.$route.params.id,
                            data: formData,
                        }

                        pushOrderMessage(payload).then(res => {
                            self.$refs.camera.value = '';
                            self.$refs.pic.value = '';
                            self.$emit('pushMessage', res.data);
                        }).catch(error => {
                            self.$emit('pushMessage', {
                                id: 0,
                                user_id: self.user.id,
                                type: 'photo',
                                messageable_type: 'Order',
                                messageable_id: 143050,
                                content: '',
                                read_at: null,
                                photos: [
                                    {
                                        id: (Math.random() * 1000000) + 1,
                                        file: result,
                                    }
                                ],
                                is_self: true,
                                created_at: moment().toISOString(),
                                isNotSend: true,
                                notSendId: (Math.random() * 1000000) + 1
                            });
                        });
                    },
                    error(err) {
                        console.log(err.message);
                    },
                });
            },
            enterMessage() {
                if (!this.isMobile) {
                    return this.pushMessage();
                }

                this.content = this.content + '\n';
            },
            pushMessage() {
                if (this.$refs.textarea) {
                    this.$refs.textarea.focus();
                }

                if (! this.content) {
                    return;
                }

                if (((new Date().getTime()) - this.enterTime) < 500) {
                    return;
                }

                let payload = {
                    id: this.$route.params.id,
                    data: {
                        type: 'text',
                        content: this.content,
                    }
                }

                pushOrderMessage(payload).then(res => {
                    this.content = '';
                    this.$emit('pushMessage', res.data);
                }).catch(error => {
                    this.$emit('pushMessage', {
                        id: 0,
                        user_id: this.user.id,
                        type: 'text',
                        messageable_type: 'Order',
                        messageable_id: 143050,
                        content: this.content,
                        read_at: null,
                        photos: [],
                        is_self: true,
                        created_at: moment().toISOString(),
                        isNotSend: true,
                        notSendId: (Math.random() * 1000000) + 1
                    });
                    this.content = '';
                });
            }
        },
    }
</script>

<style lang="scss" scoped>
    .chat-input {
        padding: 10px 15px;
        background-color: #339933;
        display: flex;
        align-items: center;

        .icon {
            display: flex;
            padding-right: 15px;
            cursor: pointer;
            user-select: none;
        }

        .input {
            flex: 1;
            position: relative;

            img {
                position: absolute;
                top: calc(50% - 14px);
                right: 8px;
                cursor: pointer;
                user-select: none;
            }

            textarea {
                padding: 8px 35px 8px 15px;
                font-size: 14px;
                letter-spacing: 0;
                color: #4a4a4a;
                border: none;
                border-radius: 18px;
                background-color: #FAFAFA;
                width: 100%;
                box-sizing: border-box;
                resize: none;

                &::-webkit-scrollbar {
                    display: none; /* for Chrome, Safari, and Opera */
                }
            }
        }
    }
</style>